import RequireAuth from 'guard';
import Layout from 'layouts';
import { Navigate, useRoutes } from 'react-router-dom';

import AdminAccount from 'pages/AdminAccount';
import ContentManagement from 'pages/ContentManagement';
import MemberInformation from 'pages/MemberInformation';
import PlaceManagement from 'pages/PlaceManagement';
import PmojiManagement from 'pages/PmojiManagement';
import Login from 'pages/User/Login';
import { CommandPopupStores } from '../pages/PopupStores/Command';
import PopupStores from '../pages/PopupStores';
import Prendies from '../pages/Prendies';
import Sugars from '../pages/Users/Sugars';
import Dashboard from '../pages/Dashboards';
import OpenNotificationApplications from '../pages/PopupStores/OpenNotificationApplications';
import Reported from '../pages/Users/Reported';
import CrawlPopupStores from '../pages/PopupStores/Crawls';
import AUStatistics from '../pages/AUStatistics';
import Notices from '../pages/Notices';
import UserSurveys from 'pages/Users/Surveys';
import AdBannersPage from 'pages/AdBanners';
import CrawlPopgaPopupStores from 'pages/PopupStores/Crawls2';
import OnlinePopupStores from 'pages/OnlinePopupStores';
import CommandOnlinePopupStores from 'pages/OnlinePopupStores/Command';
import OnlinePopupStoreStatistics from 'pages/OnlinePopupStores/Statistics';

function Routes() {
  const routes = useRoutes([
    {
      element: <Layout />,
      children: [
        {
          element: <RequireAuth />,
          children: [
            { path: '/', element: <Navigate to="/dashboards" /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [{ path: '/notices', element: <Notices /> }]
        },
        { path: '/login', element: <Login /> },
        {
          element: <RequireAuth />,
          children: [{ path: "/ad-banners", element: <AdBannersPage /> }],
        },
        {
          element: <RequireAuth />,
          children: [{ path: '/dashboards', element: <Dashboard /> }]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/member-information', element: <MemberInformation /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/place-management', element: <PlaceManagement /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/pmoji-management', element: <PmojiManagement /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/content-management', element: <ContentManagement /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [{ path: '/admin-account', element: <AdminAccount /> }]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/users/reports', element: <Reported /> },
            { path: '/users/sugars', element: <Sugars /> },
            { path: '/users/au-statistics', element: <AUStatistics /> },
            { path: "/users/surveys", element: <UserSurveys /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/popup-stores', element: <PopupStores /> },
            { path: '/popup-stores/crawls', element: <CrawlPopupStores /> },
            { path: '/popup-stores/crawls2', element: <CrawlPopgaPopupStores /> },
            { path: '/popup-stores/create', element: <CommandPopupStores /> },
            { path: '/popup-stores/open-notification-application', element: <OpenNotificationApplications /> },
            { path: '/popup-stores/:id', element: <CommandPopupStores /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/online-popup-stores', element: <OnlinePopupStores /> },
            { path: '/online-popup-stores/:id', element: <CommandOnlinePopupStores /> },
            { path: '/online-popup-stores/:id/statistics', element: <OnlinePopupStoreStatistics /> }
          ]
        },
        {
          element: <RequireAuth />,
          children: [
            { path: '/prendies', element: <Prendies /> },
          ],
        }
      ]
    }
  ]);

  return routes;
}

export default Routes;
